<!--Header-->
<app-header *ngIf="isDisplayed"></app-header>

<!--Main Content-->
<main *ngIf="!isNavigationStopped">
    <router-outlet (activate)="onActivate()"></router-outlet>
</main>

<app-preloader *ngIf="isNavigationStopped" class="navigation-stopped-preloader"></app-preloader>
<!--Footer-->
<app-footer *ngIf="isDisplayed && !isNavigationStopped"></app-footer>

<app-back-to-top-button></app-back-to-top-button>
<simple-notifications></simple-notifications>
